import useMediaQuery from '@mui/material/useMediaQuery';

/**
 * True when the user has asked the OS to minimise non-essential motion.
 * Every animation in the app (count-ups, progress fills, slide transitions, toasts)
 * must check this and fall back to an instant, static result when it returns true.
 */
export const useReducedMotion = (): boolean =>
  useMediaQuery('(prefers-reduced-motion: reduce)', { noSsr: true });
